@switch (importStatus()) {
  @case (importRecordStatusTypes.IMPORT_RECORD_STATUS_STARTED) {
    <glxy-badge [color]="'blue'">
      {{ 'IMPORTER.STATUS_BADGE.IN_PROGRESS' | translate }}
    </glxy-badge>
  }
  @case (importRecordStatusTypes.IMPORT_RECORD_STATUS_COMPLETED) {
    @if (importErrorCount() > 0) {
      <glxy-badge [color]="'yellow'">
        {{ 'IMPORTER.STATUS_BADGE.COMPLETED_WITH_ERRORS' | translate }}
      </glxy-badge>
    } @else {
      <glxy-badge [color]="'green'">
        {{ 'IMPORTER.STATUS_BADGE.COMPLETE' | translate }}
      </glxy-badge>
    }
  }
  @case (importRecordStatusTypes.IMPORT_RECORD_STATUS_ERROR) {
    <glxy-badge [color]="'red'">
      {{ 'IMPORTER.STATUS_BADGE.FAILED' | translate }}
    </glxy-badge>
  }
  @default {
    <glxy-badge [color]="'grey'" />
  }
}
